import styled, { css, DefaultTheme } from 'styled-components';

export const Container = styled.div`
  .error-message {
    color: red;
    margin-left: 16px;
    text-align: left;
  }
`;

type InputWrapperProps = {
  isValid: boolean;
  isNotValid: boolean;
  isFocus: boolean;
};

const ContainerModifier = {
  isValid: (theme: DefaultTheme) => css`
    border: 1px solid ${theme.colors.colorSuccess};
    ${Label} {
      color: ${theme.colors.colorSuccess};
    }
  `,
  isNotValid: (theme: DefaultTheme) => css`
    border: 1px solid ${theme.colors.colorDanger};
  `
};

export const InputWrapper = styled.div<InputWrapperProps>`
  ${({ isValid, isNotValid, theme }) => css`
    display: flex;
    align-items: center;
    /* position: relative; */
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #d5d5d6;
    position: relative;

    &:focus-within {
      border: 1px solid ${theme.colors.blueEinstein};
      ${isValid && ContainerModifier.isValid(theme)}
      ${isNotValid && ContainerModifier.isNotValid(theme)}
    }

    ${isNotValid && ContainerModifier.isNotValid(theme)}
  `}
`;

const LabelModifier = {
  isValid: (theme: DefaultTheme) => css`
    color: ${theme.colors.colorSuccess};
  `,
  isNotValid: (theme: DefaultTheme) => css`
    color: ${theme.colors.colorDanger};
  `,
  focus: (theme: DefaultTheme) => css`
    color: ${theme.colors.blueEinstein};
  `
};

export const Label = styled.label<InputWrapperProps>`
  position: absolute;
  top: -8px;
  left: 16px;
  font-weight: 500;
  font-size: 12px;
  background-color: var(--background-color);
  padding: 0 1px;
  color: ${props => (props.isNotValid ? '#EF4F4C' : 'var(--blue-einstein)')};
`;

type CustomInputProps = {
  icon: boolean;
  iconRight: boolean;
};

export const CustomInput = styled.input<CustomInputProps>`
  ${({ icon, iconRight }) => css`
    height: 56px;
    width: 100%;
    color: #555658;
    background: #fff;
    outline: 0;
    border: 0;
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 24px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    border-radius: 8px;
    padding: 0 16px;
    padding-left: ${icon ? '0' : '16px'};
    padding-right: ${iconRight ? '0' : '16px'};
  `}

  &::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: #898b8e;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 16px;
  }
  &::-moz-placeholder {
    /* Firefox 19+ */
    color: #898b8e;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 16px;
  }
  &::-ms-input-placeholder {
    /* IE 10+ */
    color: #898b8e;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 16px;
  }
  &::-moz-placeholder {
    /* Firefox 18- */
    color: #898b8e;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 16px;
  }

  &[type='search'] {
    font-size: 18px;
    line-height: 26px;
    font-weight: 400;
  }
`;

export const IconWrapper = styled.div`
  margin-top: 3px;
  margin-right: 16px;
  padding-left: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    width: 16px;
    height: 16px;
  }
`;
